import type { Capabilities, OutboxItem, PublicationState } from '../types';

export function canPublishOutbox(item: OutboxItem | null, capabilities: Capabilities): boolean {
  return capabilities.publishContent
    && item?.kind === 'CONTENT'
    && !!item.publication
    && item.status === 'APPROVED'
    && !!item.approvedPayloadSha256;
}

export function publicationDestination(state: PublicationState): {
  action: string;
  description: string;
  result: string;
} {
  return state === 'published'
    ? {
      action: 'Publish approved news',
      description: 'Public on /news',
      result: 'This sends the approved content to Marketing and makes it public on /news.'
    }
    : {
      action: 'Send approved draft',
      description: 'Private Marketing draft',
      result: 'This sends the approved content to Marketing as a private draft; it will not appear on /news.'
    };
}

export function approvalDecisionDescription(state: PublicationState): string {
  return state === 'published'
    ? 'Approval records the public /news destination. It does not send content; the separate send action makes it live.'
    : 'Approval records the private Marketing draft destination. It does not send content; the separate send action keeps it off /news.';
}
